/**
 * The printed "Firmado por delegación: ..." line (clinical-record-signing
 * R13). Renders nothing for a personal signature (`text` null).
 */
const DelegationLine = ({ text }: { text: string | null }) =>
  text ? <div className="delegated-signature" style={{ fontSize: '9pt', fontStyle: 'italic', color: '#444', marginTop: 2 }}>{text}</div> : null;

export default DelegationLine;
